import { useEffect } from "react";
import Marquee from "react-fast-marquee";
import { Instagram } from "lucide-react";
import { Reveal } from "./Reveal";

const reels = [
  "https://www.instagram.com/reel/DbVHn_2MdRy/",
  "https://www.instagram.com/reel/DaP3aicMsPg/",
  "https://www.instagram.com/reel/C-U_UgXqNci/",
  "https://www.instagram.com/reel/Dbv6JYmsKIW/",
];

export const InstagramReels = () => {
  useEffect(() => {
    const process = () => {
      try {
        window.instgrm?.Embeds?.process();
      } catch (e) {
        /* ignore embed errors */
      }
    };
    if (window.instgrm) {
      process();
    } else {
      const script = document.createElement("script");
      script.src = "https://www.instagram.com/embed.js";
      script.async = true;
      script.onload = process;
      script.onerror = () => {};
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section id="instagram" className="py-16 lg:py-24 px-4 sm:px-6 lg:px-10 bg-[#FAFAF8]" data-testid="instagram-section">
      <div className="max-w-7xl mx-auto bg-[#0E0E0E] rounded-3xl overflow-hidden py-8 sm:py-12 lg:py-16">
        <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 px-8 sm:px-12 lg:px-16">
          <div>
            <span className="font-heading text-xs sm:text-sm font-bold tracking-[0.25em] uppercase text-[#C6A45C]">On Instagram</span>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 leading-[1.1] text-white">
              Beyond the <em className="font-bold text-[#E7CE96]">Course</em>.
            </h2>
            <p className="mt-4 max-w-xl text-base lg:text-lg text-white/70 leading-relaxed">
              Step inside a world of smile transformations, clinical insights, hands-on learning
              and the dentists who are transforming their practice.
            </p>
          </div>
          <a
            href="https://instagram.com/drkshamamentors"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="inline-flex items-center gap-2.5 font-heading font-bold text-sm bg-[#C6A45C] text-[#0E0E0E] px-7 py-3.5 rounded-xl hover:bg-[#A88743] transition-colors duration-300 w-fit shrink-0"
          >
            <Instagram size={17} /> Follow @drkshamamentors
          </a>
        </Reveal>

        <Reveal delay={0.15} className="mt-10">
          <Marquee speed={25} gradient={false} pauseOnHover autoFill data-testid="instagram-reels-row">
            {reels.map((url, i) => (
              <div
                key={`${url}-${i}`}
                className="w-[300px] sm:w-[326px] h-[376px] sm:h-[409px] shrink-0 rounded-2xl overflow-hidden bg-[#0E0E0E] relative mx-2.5"
                data-testid="instagram-reel-embed"
              >
                <div style={{ marginTop: "-54px" }}>
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink={url}
                    data-instgrm-version="14"
                    style={{ background: "#fff", border: 0, margin: 0, padding: 0, width: "100%", minWidth: "0", pointerEvents: "none" }}
                  />
                </div>
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Watch reel on Instagram"
                  data-testid="instagram-reel-link"
                  className="absolute inset-0 z-10"
                />
              </div>
            ))}
          </Marquee>
          <p className="mt-6 font-heading text-xs font-bold tracking-[0.15em] uppercase text-white/40 px-8 sm:px-12 lg:px-16">
            Tap a reel to watch on Instagram
          </p>
        </Reveal>
      </div>
    </section>
  );
};
